module.exports = __webpack_public_path__ + "img/ring_g_o_1_0@3x.23ac5da3.png";